import "./swup.js";
import Alpine from "alpinejs";
// import focus from '@alpinejs/focus';
// import collapse from '@alpinejs/collapse';
// import intersect from '@alpinejs/intersect'

import newsletter from "./components/newsletter.js";
import stripecheckout from "./components/stripecheckout.js";
import sharearticle from "./components/sharearticle.js";

// import breakpoint from "./stores/breakpoint";

window.Alpine = Alpine;
// Alpine.plugin(collapse);
// Alpine.plugin(focus);
// Alpine.plugin(intersect);

document.addEventListener("alpine:init", () => {
    Alpine.data("newsletter", newsletter);
    Alpine.data("stripecheckout", stripecheckout);
    Alpine.data("sharearticle", sharearticle);
    // Alpine.store("breakpoint", breakpoint);
});

Alpine.start();
document.addEventListener("AppReady", () => {
    document.documentElement.classList.remove("no-fouc");
});
